import { __exports as loglevel } from "../../../../../../_virtual/loglevel.js";
var hasRequiredLoglevel;
function requireLoglevel() {
  if (hasRequiredLoglevel) return loglevel;
  hasRequiredLoglevel = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", { value: true });
    exports$1.LogLevel = void 0;
    (function(LogLevel) {
      LogLevel[LogLevel["Disable"] = 0] = "Disable";
      LogLevel[LogLevel["Error"] = 1] = "Error";
      LogLevel[LogLevel["Warn"] = 2] = "Warn";
      LogLevel[LogLevel["Info"] = 3] = "Info";
      LogLevel[LogLevel["Debug"] = 4] = "Debug";
      LogLevel[LogLevel["Verbose"] = 5] = "Verbose";
    })(exports$1.LogLevel || (exports$1.LogLevel = {}));
  })(loglevel);
  return loglevel;
}
export {
  requireLoglevel as __require
};
//# sourceMappingURL=loglevel.js.map
